import type {CreateExtArgs} from '@wix/document-manager-core'
import _ from 'lodash'
import {MASTER_PAGE_ID} from './types'

interface AutoDomReorderAPI {
    get(): boolean
    set(enabled: boolean): void
}

export const createAutoDomReorderAPI = (createExtArgs: CreateExtArgs): AutoDomReorderAPI => {
    const {dal, pointers} = createExtArgs

    const get = (): boolean => {
        const masterPageDataPointer = pointers.data.getDataItemFromMaster(MASTER_PAGE_ID)
        const dataItem = dal.get(masterPageDataPointer)
        const reorderFlag = _.get(dataItem, ['autoDomReorder'])
        return _.isUndefined(reorderFlag) ? true : reorderFlag
    }

    const set = (enabled: boolean): void => {
        if (!_.isBoolean(enabled)) {
            throw new Error('autoDomReorder.set accepts only boolean value')
        }

        const masterPageDataPointer = pointers.data.getDataItemFromMaster(MASTER_PAGE_ID)
        const dataItem = dal.get(masterPageDataPointer) || {}
        dal.set(masterPageDataPointer, {...dataItem, autoDomReorder: enabled})
    }

    return {
        get,
        set
    }
}
